import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom'

import {
    CircularProgress
} from '@material-ui/core'

import BiblioLayout from './index';
import SearchNav from 'components/SearchNav'

import { getBiblioById, updateBiblio } from 'Api'
import { useHistory } from 'react-router-dom'

export default () => {

    const params = useParams();
    const id = params.id;
    const [ biblio, setBiblio ] = useState(null);
    const [ loading, setLoading ] = useState(true);
    const location = useLocation();
    const context = (location.state && location.state.context) || null;
    const history = useHistory();


    const loadData = async (id) => {

        const biblio = await getBiblioById({ id })

        setBiblio(biblio.biblio);
        setLoading(false);
    }

    useEffect(() => {
        loadData(id);
    }, [ id ])


    let content = null;

    if (loading) {
        content = <CircularProgress />
    } else if (!id || !biblio) {
        content = "NOT FOUND"
    } else {
        content = (

            <BiblioLayout
                initialData={biblio}
                reloadData={() => loadData(id)}
                saveData={async data => {
                    await updateBiblio({ id: data.objectid, data });
                    return true;
                }}
                onSaved={() => {
                    loadData(id);
                }}
                onDelete={() => {
                    history.push("/biblio");
                }}
            />
        )
    }
    return (
        <>
            {context === 'search_result' &&
                <SearchNav
                    search_type={"biblio"}
                    constructPath={biblio => ("/biblio/" + biblio.objectid)}
                    searchPath={"/biblio/search"}
                />
            }

            {content}

        </>
    )
}